export const roundToFixed = {
  format: (value: number, count = 1): number => Number(value.toFixed(count))
};
